import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonNav, IonPage } from "@ionic/vue"
  import DiscoverPage from "@/views/DiscoverPage.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'DiscoverPageRoute',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonNav), { root: DiscoverPage })
    ]),
    _: 1
  }))
}
}

})